import Chart from 'chart.js'

export const OrdersToBeFilled = () => {
  const chart = document.getElementById('orders-to-be-filled')

  if (!chart) return

  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels').split(',')

  var myChart = new Chart(ctx, {
    type: 'pie',
    responsive: true,
    data: {
      labels: labels,
      datasets: [{
        label: false,
        data: data,
        backgroundColor: [
          '#F4F4F4',
          '#FBC434',
        ],
        borderWidth: 0
      }]
    },
    options: {
      aspectRatio: 1.5,
      legend: {
          display: false
      },
    }
  })
}
export const OrdersToBeDelivered = () => {
  const chart = document.getElementById('orders-to-be-delivered')

  if (!chart) return

  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels').split(',')

  var myChart = new Chart(ctx, {
    type: 'pie',
    responsive: true,
    data: {
      labels: labels,
      datasets: [{
        label: false,
        data: data,
        backgroundColor: [
          '#F4F4F4',
          '#FA6401',
        ],
        borderWidth: 0
      }]
    },
    options: {
      aspectRatio: 1.5,
      legend: {
          display: false
      },
    }
  })
}
export const OrdersDelivered = () => {
  const chart = document.getElementById('orders-delivered')

  if (!chart) return

  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels').split(',')

  var myChart = new Chart(ctx, {
    type: 'pie',
    responsive: true,
    data: {
      labels: labels,
      datasets: [{
        label: false,
        data: data,
        backgroundColor: [
          '#F4F4F4',
          '#8FC527',
        ],
        borderWidth: 0
      }]
    },
    options: {
      aspectRatio: 1.5,
      legend: {
          display: false
      },
    }
  })
}
export const OrdersStatus = () => {
  const chart = document.getElementById('orders-status')

  if (!chart) return

  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const labels = chart.getAttribute('labels').split(',')

  var myChart = new Chart(ctx, {
    type: 'doughnut',
    responsive: true,
    data: {
      labels: labels,
      datasets: [{
        label: false,
        data: data,
        backgroundColor: [
          '#FBC434',
          '#FA6401',
          '#8FC527',
        ],
        borderWidth: 0
      }]
    },
    options: {
      aspectRatio: 1.2,
      legend: {
          display: false
      },
    }
  })
}
export const Sales = () => {
  const chart = document.getElementById('sales')

  if (!chart) return

  const ctx = chart.getContext('2d')
  const data = chart.getAttribute('data').split(',')
  const orders = chart.getAttribute('orders').split(',')
  const labels = chart.getAttribute('labels').split(',')

  var myChart = new Chart(ctx, {
    type: 'line',
    responsive: true,
    data: {
      labels: labels,
      datasets: [{
        label: false,
        data: data,
        fill: false,
        borderColor: "#FBC434",
        borderWidth: 5,
        pointBackgroundColor: "#FBC434",
      }]
    },
    options: {
      aspectRatio: 2,
      legend: {
          display: false
      },
      elements: {
        line: {
          tension: 0
        }
      },
      tooltips: {
        /* https://www.chartjs.org/docs/latest/configuration/tooltip.html#tooltip-callbacks */
        callbacks: {
          title: function(tooltipItem) {
            const currency = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(data[tooltipItem[0].index])

            return `${currency}`
          },
          label: function(tooltipItem, data) {
            return `${orders[tooltipItem.index]} órdenes`
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: false,
            display: false,
          },
          gridLines: {
            borderDash: [0, 0],
            lineWidth: 1,
            display: false,
            zeroLineColor: "rgba(0, 0, 0, 1)",
            zeroLineWidth: 0,
          }
        }],
        xAxes: [{
          ticks: {
            beginAtZero: true,
            display: true,
          },
          gridLines: {
            borderDash: [0, 0],
            lineWidth: 1,
            display: true,
            zeroLineColor: "rgba(0, 0, 0, 1)",
            zeroLineWidth: 0,
          }
        }],
      },
    }
  })
}
